import packageJson from '../../../package.json';

export default function HealthCheck() {
    const healthCheck = {package: packageJson.name, version: packageJson.version};
    return JSON.stringify(healthCheck);
}